// L'API est pilotée par REACT_APP_API_URL (voir .env et .env.local).
// Sans variable, on retombe sur la production, comme avant.
// Attention : Create React App ne lit ces fichiers qu'au démarrage —
// il faut relancer `npm start` après les avoir modifiés.
const API_PAR_DEFAUT = "https://back.maajjal.com";

// Environnements historiques, pour mémoire :
//   recette : https://recette-api-maajjal.withvolkeno.com
//   démo    : https://demo-api-maajjal.withvolkeno.com
//   local   : http://localhost:8600

export const COLORS = {
  blue: "#021849",
  green: "#0FBF56",
  red: "#DB0909",
};

export const ApiUrl = process.env.REACT_APP_API_URL || API_PAR_DEFAUT;

export const FACEBOOK_APP_ID = "8044653658886060";
export const GOOGLE_CLIENT_ID =
  "949836911625-hdamk9uqvendrdsbq8i2nnsmse2icks8.apps.googleusercontent.com";

export const categories = [
  { label: "Agricole", value: "agricole", id: 0 },
  { label: "Commerce", value: "commerce", id: 1 },
  { label: "Transport", value: "transport", id: 2 },
  { label: "Immobilier", value: "immobilier", id: 3 },
  { label: "Services", value: "services", id: 4 },
  { label: "Sociale", value: "sociale", id: 5 },
  { label: "Autres", value: "autres", id: 6 },
];
// Ce que le porteur choisit pour son projet. La validation (qui ouvre les
// contributions) reste a l'admin et n'apparait pas ici.
export const etatProjet = [
  { label: "Public — visible sur la plateforme (après validation)", value: "public" },
  { label: "Privé — accessible uniquement par son lien", value: "prive" },
  { label: "Terminé — clôturer la campagne", value: "termine" },
];

export const ORDER_STATUT_SELECT = [
  { value: "en_attente", label: "Non validée" },
  { value: "en_cours", label: "En cours" },
  { value: "annuler", label: "Annulée" },
  { value: "livrer", label: "Livrée" },
  { value: "valide", label: "Validée" },
  { value: "payer", label: "Payée" },
  { value: "refuser", label: "Refusée" },
];
export const ORDER_STATUT = {
  en_attente: {
    label: ORDER_STATUT_SELECT[0].label,
    color: "#f39c12",
  },
  en_cours: {
    label: ORDER_STATUT_SELECT[1].label,
    color: "#16a085",
  },
  annuler: {
    label: ORDER_STATUT_SELECT[2].label,
    color: "#c0392b",
  },

  livrer: {
    label: ORDER_STATUT_SELECT[3].label,
    color: "#16a085",
  },
  valide: {
    label: ORDER_STATUT_SELECT[4].label,
    color: "#16a085",
  },
  payer: {
    label: ORDER_STATUT_SELECT[5].label,
    color: "#16a085",
  },
  refuser: {
    label: ORDER_STATUT_SELECT[6].label,
    color: "#d35400",
  },
};
